import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Typography,
  Divider,
  Table,
  Modal,
  Input,
  InputNumber,
  Layout,
  Form,
} from "antd";

import Icon, { LeftOutlined, RightOutlined, SearchOutlined, TrophyOutlined, DollarOutlined, MoneyCollectOutlined, DislikeOutlined, DislikeFilled, NodeIndexOutlined, RiseOutlined, DashboardOutlined, ThunderboltOutlined, HeartOutlined, CompassOutlined, StarOutlined, ClockCircleOutlined, PlayCircleOutlined, PlayCircleFilled } from "@ant-design/icons";

import { AppContext } from "contexts/AppContext";

import {
  ACTION,
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
  VIEW_TYPE
} from "constants/index";
import emptyImg from "../../assets/img/empty.svg";
import AuthorizedFunction from "config/AuthorizedFunction";
import GeneralHelper from "helper/general.helper";
import NoteService from "services/note.service";
import { setUserWallet } from "redux/actions/auth.action";
const { Title } = Typography;

const initialValues = {
  activity_keyword: null,
  activity_distance: null,
  activity_elevation_gain: null,
  startDate: null,
  endDate: null
};

const SearchModal = ({ onUpdate, onClose, open = false }) => {
  const appContext = useContext(AppContext);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      onClear();
    }
   }, [open]);

  const onClear = () => {
    appContext.setSearchParams(null);
    form.setFieldsValue(initialValues);
  };

  const handleCancel = () => {
    onClose(false);
  };

  const handleSubmit = (e) => {
    form
      .validateFields()
      .then((params) => {
        console.log(params);

        if (!params.activity_keyword && !params.activity_distance && !params.activity_elevation_gain) {
          onClear();
          return Promise.reject();
        }

        const searchParams = {
          activity_keyword: params.activity_keyword || null,
          activity_distance: params.activity_distance || null,
          activity_elevation_gain: params.activity_elevation_gain || null,
          startDate: null,
          endDate: null,
        };
        appContext.setSearchParams(searchParams);
        appContext.setCallSearch(moment().valueOf());

        onClose(false);
        onUpdate(searchParams);
      })
      .catch((e) => {
        message.warning("Enter at least 1 search params", 3);
      });
  };

  return (
    <Modal
      className="search-panel"
      open={open}
      title={`Search ${appContext.sportView}`}
      onOk={handleSubmit}
      onCancel={handleCancel}
      width={350}
      footer={[
        <Button
          className="btn btn-primary btn-cmd"
          key="submit"
          type="primary"
          loading={isLoading}
          onClick={handleSubmit}
        >
          <SearchOutlined />
        </Button>,
      ]}
    >
      <Divider />
      <Form layout="vertical" initialValues={initialValues} form={form}>
        <Space direction="vertical" size="very-small">
          <Form.Item
            name="activity_keyword"
            // label="Keyword"
            // rules={[{ required: true, message: "Activity keyword is required" }]}
          >
            <Input
              placeholder={`${appContext.sportView} keyword`}
              autoFocus
              allowClear
            />
          </Form.Item>

          <Form.Item
            name="activity_distance"
            // label="Distance"
            // rules={[{ required: true, message: "Distance is required" }]}
          >
            <InputNumber
              min="1"
              step="1"
              placeholder="Min distance (km)"
              allowClear
            />
          </Form.Item>

          <Form.Item
            name="activity_elevation_gain"
            // label="Elevation gain"
            // rules={[{ required: true, message: "Elevation gain is required" }]}
          >
            <InputNumber
              min="1"
              step="1"
              placeholder="Min elevation gain (m)"
              allowClear
            />
          </Form.Item>
        </Space>
      </Form>
      <Divider />
    </Modal>
  );
};
export default SearchModal;
